exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box{margin-bottom:20px;padding-left:15px;padding-right:15px;background-color:#fff;border:1px solid #ddd;border-radius:4px}.box .title{margin:0;padding:15px 0;letter-spacing:-.02em}.box .chevron{float:right;top:inherit!important;font-size:.8em}.box .box-content{padding:0 0 20px}", ""]);

// exports
